import React from 'react';
import './EmptyBox.css';

export const EmptyBox = (props) => {


  return (
    <div className="empty-box-container">
            <span className="empty-box-text" style={{
              fontSize: "0.75rem",
              textAlign: "center"
            }}>{props?.label || "No Data Available"}</span>
    </div>
  );
};

